import React from "react";
import "../../../../style/buttons.scss";

interface IProps {
  title: string;
  variant?: "filled" | "outlined" | "text";
  color?: "primary" | "secondary" | "error";
  onClick?: () => void;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  fullWidth?: boolean;
  disabled?: boolean;
  inputType?: "button" | "submit" | "reset" | undefined;
  loading?: boolean;
  loadingText?: string;
  noMargins?: boolean;
}

const EAButton: React.FC<IProps> = ({
  title,
  variant = "filled",
  color = "primary",
  onClick = () => {},
  startIcon,
  endIcon,
  fullWidth = false,
  disabled = false,
  inputType = "button",
  loading = false,
  loadingText = "Ładowanie...",
  noMargins = false,
}) => {
  return (
    <button
      className={`button button--${variant} button--${color} ${fullWidth ? "button--fullWidth" : ""} ${
        noMargins ? "button--no-margins" : ""
      }`}
      onClick={onClick}
      disabled={disabled || loading}
      type={inputType}
    >
      {loading ? (
        <span className="button__text button-text">{loadingText}</span>
      ) : (
        <>
          {" "}
          {startIcon && <span className="button__icon button__icon--start">{startIcon}</span>}
          <span className="button__text button-text">{title}</span>
          {endIcon && <span className="button__icon button__icon--end">{endIcon}</span>}
        </>
      )}
    </button>
  );
};

export default EAButton;
